msgid ""
msgstr ""
"POT-Creation-Date: 2026-03-09 13:54+0100\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: nb\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#: src/client/components/Hierarchy/ConfirmOrgConnectionModal.tsx:45
msgid " sin bedriftsprofil."
msgstr ""

#: src/client/components/Hierarchy/ConfirmOrgConnectionModal.tsx:44
msgid " vil bruke "
msgstr ""

#: src/client/components/ImagesSection/ImagesEdit/ImagesEditForm.tsx:30
msgid "(Valgfritt)"
msgstr ""

#. placeholder {0}: totalFollowers ?? 0
#: src/client/components/StatisticsModal/StatisticsSummary.tsx:19
msgid "{0, plural, one {Følger totalt} other {Følgere totalt}}"
msgstr ""

#. placeholder {0}: newFollowers ?? 0
#: src/client/components/StatisticsModal/StatisticsSummary.tsx:26
msgid "{0, plural, one {Ny følger} other {Nye følgere}}"
msgstr ""

#. placeholder {0}: modalContent[type].title
#: src/client/components/ImageEditor/ImageEditorModal.tsx:122
msgid "{0}"
msgstr ""

#: src/client/components/Hierarchy/ConfirmOrgConnectionModal.tsx:59
msgid "{childName} vil få sin egen bedriftsprofil."
msgstr ""

#. js-lingui-explicit-id
#: src/client/components/StatisticsModal/statisticsChartOptions.ts:18
msgid "statistics.uniqueViews"
msgstr ""

#. js-lingui-explicit-id
#: src/client/components/StatisticsModal/statisticsChartOptions.ts:12
msgid "statistics.newFollowers"
msgstr ""

#. js-lingui-explicit-id
#: src/server/renderProfilePage.ts:62
msgid "page.title.seekers"
msgstr "{displayName} profil og ledige stillinger | FINN jobb"

#: src/islands/hierarchyPage/Hierarchy.tsx:33
msgid "Administrer tilknyttede organisasjoner"
msgstr ""

#: src/client/components/ExtendedProfileForm/ExtendedProfileInheritedView.tsx:102
msgid "Administreres av {ownerName}"
msgstr ""

#: src/islands/extendedProfilePage/ExtendedProfilePage.tsx:72
msgid "Aktivert"
msgstr ""

#: src/client/components/Hierarchy/HierarchyFilter.tsx:51
msgid "Alle"
msgstr ""

#: src/client/components/Onboarding/OnboardingEditorModal.tsx:27
msgid "Alle stillinger samlet"
msgstr ""

#: src/client/components/ImageEditor/LogoCheck.tsx:94
msgid "Anbefalt format"
msgstr ""

#: src/client/components/ImageEditor/ImageEditorModal.tsx:67
msgid "Anbefalt format: Kvadratisk logo (1:1-format). PNG, JPEG eller JPG. {IMAGE_MIN_SIZE}×{IMAGE_MIN_SIZE} piksler minimum."
msgstr ""

#: src/client/components/Hierarchy/ConfirmOrgConnectionModal.tsx:50
msgid "Annonser lenker til denne bedriftsprofilen"
msgstr ""

#: src/client/components/Hierarchy/ConfirmOrgConnectionModal.tsx:60
msgid "Annonser lenker til egen bedriftsprofil"
msgstr ""

#: src/client/components/ImagesSection/ImagesPreview.tsx:47
msgid "av"
msgstr ""

#: src/client/components/ExtendedProfileForm/ExtendedProfileForm.tsx:210
#: src/client/components/ExtendedProfileForm/ExtendedProfileInheritedView.tsx:111
#: src/client/components/Hierarchy/ConfirmOrgConnectionModal.tsx:69
#: src/client/components/ProfileToolbar/EditModeToolbar.tsx:120
msgid "Avbryt"
msgstr ""

#: src/client/components/ExtendedProfileForm/ExtendedProfileForm.tsx:111
#: src/client/components/ExtendedProfileForm/ExtendedProfileInheritedView.tsx:40
msgid "Bakgrunnsfarge"
msgstr ""

#: src/client/components/ExtendedProfileForm/ExtendedProfileForm.tsx:108
msgid "Bakgrunnsfarge er påkrevd"
msgstr ""

#: src/client/components/ProfileToolbar/PreviewModeSwitch.tsx:35
#: src/islands/hierarchyPage/Hierarchy.tsx:25
msgid "Bedriftsprofil"
msgstr ""

#: src/client/components/Onboarding/OnboardingEditorModal.tsx:62
msgid "Bedriftsprofilen – dette ser kandidatene"
msgstr ""

#: src/client/components/ProfileContent.tsx:102
msgid "Bedriftsprofilen administreres sentralt av "
msgstr ""

#. js-lingui-explicit-id
#: src/server/renderExtendedProfilePage.ts:57
#: src/server/renderHierarchyPage.ts:55
#: src/server/renderProfilePage.ts:67
#: src/server/renderProfilePage.ts:71
msgid "page.title.recruiters"
msgstr ""

#: src/client/components/VideosSection/VideoField.tsx:29
msgid "Beskrivelse"
msgstr ""

#: src/client/components/StatisticsModal/StatisticsChart.tsx:84
msgid "Besøkende per dag"
msgstr ""

#: src/client/components/ImageEditor/ImageEditorModal.tsx:70
msgid "bilde"
msgstr ""

#: src/client/components/AddSectionButton/AddSectionButton.tsx:31
msgid "Bilder"
msgstr ""

#: src/client/components/ExtendedProfileForm/Preview/CardPreview.tsx:43
msgid "Bilder hentes automatisk fra Bedriftsprofilen din"
msgstr ""

#: src/client/components/ExtendedProfileForm/Preview/CardPreview.tsx:47
msgid "Bilder tagget med stillingsfunksjon prioriteres. Dersom ingen bilder er tagget, brukes første bilde fra bildegalleriet i bedriftsprofilen."
msgstr ""

#: src/client/components/ImagesSection/ImagesEdit/ImagesEditForm.tsx:89
msgid "Bildetekst"
msgstr ""

#: src/client/components/CompanyDetails/FollowButton.tsx:30
msgid "Bli varslet om nye stillinger"
msgstr ""

#: src/client/components/AddSectionButton/AddSectionButton.tsx:90
msgid "Del mer om dere"
msgstr ""

#: src/client/components/EmptyMessage.tsx:26
msgid "Denne organisasjonen har ingen underselskaper som kan kobles til"
msgstr ""

#: src/client/components/ActiveAds/EditModeActiveAds.tsx:13
msgid "Deres ledige stillinger vises her "
msgstr ""

#: src/client/components/ActiveAds/EmptyActiveAds.tsx:47
msgid "Det er for tiden ingen ledige stillinger hos "
msgstr ""

#: src/client/components/Hierarchy/ConfirmOrgConnectionModal.tsx:120
msgid "Dette skjer:"
msgstr ""

#: src/client/components/ImageEditor/DropZone.tsx:37
msgid "Dra og slipp, eller klikk for å laste opp"
msgstr ""

#: src/client/components/ImageEditor/LogoCheck.tsx:51
msgid "Du er klar til å publisere."
msgstr ""

#: src/client/components/ExtendedProfileForm/ExtendedProfileModal.tsx:33
msgid "Du har gjort endringer som ikke er lagret. Hvis du forlater siden nå, mister du disse endringene."
msgstr ""

#: src/client/components/ProfileToolbar/EditModeToolbar.tsx:161
msgid "Du har gjort endringer som ikke er publisert. Hvis du forlater siden nå, mister du disse endringene."
msgstr ""

#: src/client/components/Hierarchy/ConfirmOrgConnectionModal.tsx:60
msgid "Egen profil, logo og tekst brukes som standard"
msgstr ""

#: src/client/components/Onboarding/OnboardingEditModal.tsx:63
msgid "Endre rekkefølge"
msgstr ""

#: src/client/components/ExtendedProfileForm/ExtendedProfileContent.tsx:48
#: src/client/components/ExtendedProfileForm/ExtendedProfileContent.tsx:67
msgid "Endringene er lagret"
msgstr ""

#: src/client/components/EmptyMessage.tsx:36
msgid "er gjort, kan du aktivere tydelig profil her."
msgstr ""

#. js-lingui-explicit-id
#: src/server/renderProfilePage.ts:77
msgid "og.title"
msgstr "Et blikk på innsiden av {displayName}"

#: src/client/components/ExtendedProfileForm/Preview/ExtendedProfilePreview.tsx:48
msgid "Få mer ut av stillingsannonsene dine ved å tagge bilder med stillingsfunksjon i bedriftsprofilen. Da vises riktig bilde i riktig annonse."
msgstr ""

#: src/client/components/Onboarding/OnboardingEditModal.tsx:44
msgid "Få mest mulig ut av bedriftsprofilen"
msgstr ""

#: src/client/components/ExtendedProfileForm/ExtendedProfileForm.tsx:124
#: src/client/components/ExtendedProfileForm/ExtendedProfileInheritedView.tsx:49
msgid "Farge på knapp"
msgstr ""

#: src/client/components/ImageUploader.tsx:36
msgid "Filen er for stor (maks {FILE_SIZE_IN_MB}MB)"
msgstr ""

#. js-lingui-explicit-id
#: src/server/renderProfilePage.ts:84
msgid "og.site_name"
msgstr "FINN.no Bedriftsprofiler"

#: src/client/components/Hierarchy/HierarchyTable.tsx:41
msgid "Firmanavn"
msgstr ""

#: src/client/components/Hierarchy/HierarchyRow.tsx:89
msgid "Fjern tilknytning"
msgstr ""

#: src/client/components/Hierarchy/ConfirmOrgConnectionModal.tsx:57
msgid "Fjern tilknytning til {childName}?"
msgstr ""

#: src/client/components/ExtendedProfileForm/ExtendedProfileActivationSection.tsx:82
msgid "Fjernes fra eksisterende annonser, og nye annonser vil ikke få produktet eller bli fakturert."
msgstr ""

#: src/client/components/ExtendedProfileForm/Preview/CardPreview.tsx:122
msgid "Flere stillinger"
msgstr ""

#: src/client/components/SectionToolbar/SectionToolbar.tsx:73
msgid "Flytt ned"
msgstr ""

#: src/client/components/SectionToolbar/SectionToolbar.tsx:61
msgid "Flytt opp"
msgstr ""

#: src/client/components/SectionToolbar/SectionToolbar.tsx:72
msgid "Flytt seksjon ned"
msgstr ""

#: src/client/components/SectionToolbar/SectionToolbar.tsx:60
msgid "Flytt seksjon opp"
msgstr ""

#: src/client/components/Onboarding/OnboardingEditModal.tsx:64
msgid "Flytt seksjonene opp eller ned og bestem hva kandidatene skal se først. Fremhev det som er viktigst for dere."
msgstr ""

#: src/client/components/CompanyDetails/CompanyDetails.tsx:83
msgid "følger"
msgstr ""

#: src/client/components/CompanyDetails/FollowButton.tsx:30
msgid "Følger"
msgstr ""

#: src/client/components/CompanyDetails/CompanyDetails.tsx:83
msgid "følgere"
msgstr ""

#: src/client/components/StatisticsModal/StatisticsModal.tsx:30
msgid "Følgere"
msgstr ""

#: src/client/components/Onboarding/OnboardingEditorModal.tsx:22
msgid "Følgere får varsel om nye stillinger"
msgstr ""

#: src/client/components/ProfileToolbar/Toolbar.tsx:24
msgid "Følgerstatistikk"
msgstr ""

#: src/client/components/ImageEditor/LogoCheck.tsx:39
msgid "For best resultat bør logoen være minst {IMAGE_MIN_SIZE}X{IMAGE_MIN_SIZE} piksler. Nå er den"
msgstr ""

#: src/client/components/ImageEditor/LogoCheck.tsx:97
msgid "For best resultat, bruk en firkantet logo (1:1) som er minst {IMAGE_MIN_SIZE} x {IMAGE_MIN_SIZE} piksler, med farget bakgrunn."
msgstr ""

#: src/client/components/ExtendedProfileForm/Preview/CardPreview.tsx:164
#: src/client/components/ImageEditor/LogoCheck.tsx:65
msgid "Forhåndsvisning"
msgstr ""

#: src/client/components/ExtendedProfileForm/Preview/CardPreview.tsx:63
msgid "Forhåndsvisningen oppdateres når du legger til innhold"
msgstr ""

#: src/client/components/ExtendedProfileForm/ExtendedProfileModal.tsx:24
#: src/client/components/ProfileToolbar/EditModeToolbar.tsx:152
msgid "Forkast endringer og forlat siden"
msgstr ""

#: src/client/components/CompanyDetails/Description/DescriptionEdit.tsx:35
msgid "Fortell kort hvem der er,  hva dere gjør - og hvorfor folk burde jobbe hos dere. "
msgstr ""

#: src/client/components/ExtendedProfileForm/ExtendedProfileModal.tsx:27
msgid "Fortsett å redigere"
msgstr ""

#: src/client/components/ExtendedProfileForm/LinkRow.tsx:36
#: src/client/components/ExtendedProfileForm/LinkRow.tsx:56
msgid "Fyll ut begge feltene"
msgstr ""

#: src/islands/extendedProfilePage/ExtendedProfilePage.tsx:77
msgid "Gi annonsene et ekstra løft med en egen seksjon som fremhever merkevaren din — med egne farger, overskrift og lenker."
msgstr ""

#: src/client/components/Onboarding/OnboardingEditModal.tsx:54
msgid "Gjør det enklere for kandidater å kjenne dere igjen. Logoen brukes automatisk i alle nye annonser."
msgstr ""

#: src/islands/hierarchyPage/Hierarchy.tsx:36
msgid "Her kan du koble til organisasjoner som skal dele bedriftsprofil, logo og merkevare."
msgstr ""

#: src/client/components/ExtendedProfileForm/ExtendedProfileForm.tsx:154
msgid "Her kan du legge til lenker som viser hvem dere er – for eksempel karriereside eller sosiale medier; kandidater sjekker ofte denne type innhold før de søker på stillinger."
msgstr ""

#: src/client/components/ImagesSection/ImagesEdit/ImagesEditForm.tsx:95
msgid "Her kan du skrive en fiffig bildetekst"
msgstr ""

#: src/client/components/ActiveAds/ActiveAds.tsx:169
#: src/client/components/EmptyMessage.tsx:21
msgid "Her var det tomt gitt!"
msgstr ""

#: src/client/components/CompanyDetails/HomepageLink/HomepageLinkEdit.tsx:43
msgid "Hjemmeside"
msgstr ""

#: src/client/components/Onboarding/OnboardingEditModal.tsx:47
msgid "Hopp over"
msgstr ""

#: src/client/components/ExtendedProfileForm/ExtendedProfileForm.tsx:186
msgid "Hovedknapp"
msgstr ""

#: src/client/components/ExtendedProfileForm/Preview/ExtendedProfilePreview.tsx:44
msgid "Husk å velge bilder"
msgstr ""

#: src/client/components/ExtendedProfileForm/Preview/ExtendedProfilePreview.tsx:55
msgid "Hvis du ikke tagger noen bilder, blir det første bildet i bildegalleriet brukt."
msgstr ""

#: src/client/components/Hierarchy/HierarchyFilter.tsx:54
#: src/client/components/Hierarchy/HierarchyRow.tsx:42
msgid "Ikke tilknyttet"
msgstr ""

#: src/islands/extendedProfilePage/ExtendedProfilePage.tsx:72
msgid "Inaktiv"
msgstr ""

#: src/client/components/CompanyDetails/Description/DescriptionEdit.tsx:34
msgid "Informasjon om firma"
msgstr ""

#: src/client/components/ExtendedProfileForm/Preview/CardPreview.tsx:82
msgid "Ingen bilder i bildegalleriet"
msgstr ""

#: src/client/components/ActiveAds/EmptyActiveAds.tsx:25
msgid "Ingen ledige stillinger"
msgstr ""

#: src/client/components/ExtendedProfileForm/ExtendedProfileActivationSection.tsx:49
msgid "Ja, aktiver Tydelig Profil"
msgstr ""

#: src/client/components/Hierarchy/ConfirmOrgConnectionModal.tsx:61
msgid "Ja, fjern tilknytning"
msgstr ""

#: src/client/components/Hierarchy/ConfirmOrgConnectionModal.tsx:53
msgid "Ja, opprett tilknytning"
msgstr ""

#: src/client/components/Onboarding/OnboardingEditModal.tsx:59
msgid "Jo flere seksjoner du legger til, jo mer kan du dele – som bilder, videoer og annet spennende innhold som får profilen til å skinne."
msgstr ""

#: src/client/components/Onboarding/OnboardingEditorModal.tsx:28
msgid "Kandidater finner lett andre relevante jobber hos dere."
msgstr ""

#: src/client/components/Onboarding/OnboardingEditorModal.tsx:23
msgid "Kandidater som følger bedriften får automatisk melding når nye annonser blir publisert. Økt rekkevidde uten ekstra arbeid."
msgstr ""

#: src/client/components/ExtendedProfileForm/ExtendedProfileForm.tsx:121
msgid "Knappefarge er påkrevd"
msgstr ""

#: src/client/components/Onboarding/OnboardingEditModal.tsx:65
msgid "Kom i gang"
msgstr ""

#: src/client/components/ExtendedProfileForm/ExtendedProfileContent.tsx:49
#: src/client/components/ExtendedProfileForm/ExtendedProfileContent.tsx:68
#: src/client/components/ExtendedProfileForm/ExtendedProfileContent.tsx:74
msgid "Kunne ikke lagre. Prøv igjen senere."
msgstr ""

#: src/client/components/ExtendedProfileForm/ExtendedProfileForm.tsx:213
#: src/client/components/ExtendedProfileForm/ExtendedProfileInheritedView.tsx:114
#: src/client/components/ImageEditor/ImageEditorModal.tsx:135
msgid "Lagre"
msgstr ""

#: src/client/components/ProfileToolbar/EditModeToolbar.tsx:130
msgid "Lagre og publiser"
msgstr ""

#: src/client/components/ImageEditor/ImageEditorModal.tsx:121
msgid "Last opp "
msgstr ""

#: src/client/components/AmbassadorsSection/AmbassadorLogo.tsx:58
msgid "Last opp bilde"
msgstr ""

#: src/client/components/Onboarding/OnboardingEditModal.tsx:53
msgid "Last opp eller endre logo"
msgstr ""

#: src/client/components/ImageEditor/ImageCropper.tsx:212
msgid "Last opp nytt bilde"
msgstr ""

#: src/client/components/ActiveAds/ActiveAds.tsx:42
msgid "Ledige stillinger"
msgstr ""

#: src/client/components/ActiveAds/EmptyActiveAds.tsx:28
msgid "Ledige stillinger er det kandidatene kikker etter først – derfor ligger de øverst på bedriftsprofilen. Legg ut en annonse og vis kandidatene hva dere ser etter!"
msgstr ""

#: src/client/components/ActiveAds/EditModeActiveAds.tsx:16
msgid "Ledige stillinger er det viktigste for kandidatene. Derfor viser vi dem øverst, så drømmekandidaten enkelt finner jobbene dere har utlyst."
msgstr ""

#: src/client/components/ActiveAds/ActiveAds.tsx:42
msgid "Ledige stillinger hos {displayName}"
msgstr "Ledige stillinger hos {displayName}"

#: src/client/components/VideosSection/AddVideoField.tsx:36
msgid "Legg inn lenke til en video fra YouTube eller Vimeo"
msgstr ""

#: src/client/components/CompanyDetails/Description/Description.tsx:79
msgid "Legg til beskrivelse"
msgstr ""

#: src/client/components/ImagesSection/ImagesEdit/ImagesEditGallery.tsx:189
msgid "Legg til bilder"
msgstr ""

#: src/client/components/CompanyDetails/HomepageLink/HomepageLink.tsx:39
msgid "Legg til hjemmeside"
msgstr ""

#: src/client/components/ExtendedProfileForm/ExtendedProfileForm.tsx:175
msgid "Legg til lenke"
msgstr ""

#: src/client/components/AmbassadorsSection/AmbassadorEditMode.tsx:70
msgid "Legg til medarbeider"
msgstr ""

#: src/client/components/ExtendedProfileForm/LinkRow.tsx:33
msgid "Legg til minst én lenke"
msgstr ""

#: src/client/components/Onboarding/OnboardingEditModal.tsx:58
msgid "Legg til seksjoner"
msgstr ""

#: src/client/components/AddSectionButton/AddSectionButton.tsx:92
msgid "Legg til seksjoner med bilder og annet innhold"
msgstr ""

#: src/client/components/TopImage/EmptyTopImage.tsx:19
msgid "Legg til toppbilde (980 x 375px)"
msgstr ""

#: src/client/components/VideosSection/AddVideoField.tsx:48
msgid "Legg til video"
msgstr ""

#: src/client/components/ExtendedProfileForm/ExtendedProfileForm.tsx:150
#: src/client/components/ExtendedProfileForm/ExtendedProfileInheritedView.tsx:68
msgid "Lenker"
msgstr ""

#: src/client/components/ExtendedProfileForm/LinkRow.tsx:42
msgid "Lenketekst"
msgstr ""

#: src/client/components/AmbassadorsSection/AmbassadorCard.tsx:37
#: src/client/components/CompanyDetails/Description/Description.tsx:118
#: src/client/components/Onboarding/OnboardingEditorTip.tsx:27
msgid "Les mer"
msgstr ""

#: src/client/components/AmbassadorsSection/AmbassadorCard.tsx:37
msgid "Les mindre"
msgstr ""

#: src/client/components/ImageEditor/ImageEditorModal.tsx:64
msgid "logo"
msgstr ""

#: src/client/components/ImageEditor/LogoCheck.tsx:50
msgid "Logoen er innenfor anbefalingene våre."
msgstr ""

#: src/client/components/ImageEditor/LogoCheck.tsx:36
msgid "Logoen kan bli skarpere."
msgstr ""

#: src/client/components/ImageEditor/LogoCheck.tsx:68
msgid "Logoen vises i stillingsannonser, i søkeresultatet, på bedriftsprofilen og ved profilering i eksterne kanaler."
msgstr ""

#: src/client/components/ImagesSection/ImagesPreview.tsx:43
#: src/client/components/Onboarding/OnboardingEditorModal.tsx:55
#: src/client/components/SectionToolbar/SectionToolbar.tsx:50
msgid "Lukk"
msgstr ""

#: src/client/components/SectionToolbar/SectionToolbar.tsx:49
msgid "Lukk seksjon"
msgstr ""

#: src/client/components/AddSectionButton/AddSectionButton.tsx:57
msgid "Medarbeidere"
msgstr ""

#: src/client/components/ActiveAds/EmptyActiveAds.tsx:53
msgid "Men det betyr ikke at det ikke finnes muligheter!"
msgstr ""

#: src/client/components/ExtendedProfileForm/ExtendedProfileForm.tsx:101
#: src/client/components/ExtendedProfileForm/ExtendedProfileInheritedView.tsx:91
msgid "Merkevare"
msgstr ""

#: src/client/components/ExtendedProfileForm/ExtendedProfileInheritedView.tsx:95
msgid "Merkevaren styres sentralt av {ownerName}. Kontakt eier dersom du ønsker din egen bedriftsprofil."
msgstr ""

#: src/client/components/AmbassadorsSection/AmbassadorForm.tsx:106
msgid "Navn"
msgstr ""

#: src/client/components/ExtendedProfileForm/ExtendedProfileActivationSection.tsx:79
msgid "Nei, ikke aktiver Tydelig Profil"
msgstr ""

#: src/client/components/Onboarding/OnboardingEditModal.tsx:135
msgid "Neste"
msgstr ""

#: src/client/components/AmbassadorsSection/AmbassadorsSection.tsx:105
msgid "Noen av våre medarbeidere"
msgstr ""

#: src/client/components/StatisticsModal/StatisticsChart.tsx:81
msgid "Nye følgere"
msgstr ""

#: src/client/components/StatisticsModal/StatisticsChart.tsx:72
msgid "Nye følgere de siste 14 dagene"
msgstr ""

#: src/client/components/ExtendedProfileForm/ExtendedProfileActivationSection.tsx:21
msgid "Ønsker du å vise Tydelig Profil på stillingsannonsene til denne bedriften?"
msgstr ""

#: src/client/components/Hierarchy/HierarchyRow.tsx:100
msgid "Opprett tilknytning"
msgstr ""

#: src/client/components/Hierarchy/ConfirmOrgConnectionModal.tsx:39
msgid "Opprett tilknytning til {childName}?"
msgstr ""

#: src/client/components/ExtendedProfileForm/ExtendedProfileForm.tsx:140
#: src/client/components/ExtendedProfileForm/ExtendedProfileInheritedView.tsx:59
msgid "Overskrift"
msgstr ""

#: src/client/components/ExtendedProfileForm/ExtendedProfileForm.tsx:137
msgid "Overskrift er påkrevd"
msgstr ""

#: src/client/components/Hierarchy/ConfirmOrgConnectionModal.tsx:49
msgid "Profil, logo og tekst settes som standard"
msgstr ""

#: src/client/components/ActiveAds/EmptyActiveAds.tsx:68
msgid "Prøv SmartSøk"
msgstr ""

#: src/client/components/ProfileToolbar/EditModeToolbar.tsx:155
msgid "Publiser endringer"
msgstr ""

#: src/client/components/AmbassadorsSection/AmbassadorLogo.tsx:90
#: src/client/components/ProfileToolbar/Toolbar.tsx:58
#: src/client/components/SectionToolbar/SectionToolbar.tsx:50
msgid "Rediger"
msgstr ""

#: src/client/components/ProfileToolbar/EditModeToolbar.tsx:102
msgid "Rediger bedriftsprofil"
msgstr ""

#: src/client/components/ExtendedProfileForm/Preview/ExtendedProfilePreview.tsx:63
#: src/client/components/Onboarding/OnboardingEditorTip.tsx:17
msgid "Rediger bedriftsprofilen"
msgstr ""

#: src/client/components/SectionToolbar/SectionToolbar.tsx:49
msgid "Rediger seksjon"
msgstr ""

#: src/client/components/TopImage/FilledTopImage.tsx:36
msgid "Rediger toppbilde"
msgstr ""

#: src/client/components/Onboarding/OnboardingEditModal.tsx:48
msgid "Se hvordan"
msgstr ""

#: src/client/components/AmbassadorsSection/AmbassadorForm.tsx:74
msgid "Sitat"
msgstr ""

#: src/client/components/AmbassadorsSection/AmbassadorForm.tsx:132
#: src/client/components/SectionToolbar/SectionToolbar.tsx:85
msgid "Slett"
msgstr ""

#: src/client/components/ImageEditor/ImageCropper.tsx:229
#: src/client/components/ImagesSection/ImagesEdit/ImagesEditForm.tsx:141
msgid "Slett bilde"
msgstr ""

#: src/client/components/ExtendedProfileForm/LinkRow.tsx:67
msgid "Slett lenke"
msgstr ""

#: src/client/components/SectionToolbar/SectionToolbar.tsx:84
msgid "Slett seksjon"
msgstr ""

#: src/client/components/VideosSection/VideoField.tsx:43
msgid "Slett video"
msgstr ""

#: src/client/components/ExtendedProfileForm/Preview/ExtendedProfilePreview.tsx:74
#: src/client/components/ExtendedProfileForm/Preview/ExtendedProfilePreview.tsx:92
msgid "Slik vises Tydelig Profil i annonsene deres"
msgstr ""

#: src/client/components/ActiveAds/EmptyActiveAds.tsx:56
msgid "SmartSøk finner jobber som ligner – også fra andre bedrifter du kan like."
msgstr ""

#: src/client/components/Hierarchy/HierarchyFilter.tsx:37
msgid "Søk"
msgstr ""

#: src/client/components/ActiveAds/ActiveAds.tsx:132
msgid "Søk etter stillingstittel"
msgstr ""

#: src/client/components/Hierarchy/HierarchyFilter.tsx:36
msgid "Søk etter underorganisasjon"
msgstr ""

#: src/client/components/ImageUploader.tsx:56
msgid "Something went wrong"
msgstr ""

#: src/client/components/Hierarchy/HierarchyFilter.tsx:45
#: src/client/components/Hierarchy/HierarchyTable.tsx:44
msgid "Status"
msgstr ""

#: src/client/components/ImageEditor/DropZone.tsx:40
msgid "Støttede filtyper: PNG, JPEG, JPG"
msgstr ""

#: src/client/components/Hierarchy/HierarchyContent.tsx:72
msgid "Ta kontakt med <0>jobb.finn@vend.com</0> dersom det mangler en organisasjon."
msgstr ""

#: src/client/components/EmptyMessage.tsx:28
msgid "Ta kontakt med <0>jobb.finn@vend.com</0> dersom dette skal oppdateres."
msgstr ""

#: src/client/components/ProfileContent.tsx:104
msgid "Ta kontakt med eieren av denne bedriftsprofilen dersom du ønsker å koble den fra og bruke din egen bedriftsprofil og merkevare."
msgstr ""

#: src/client/components/ImagesSection/ImagesEdit/ImagesEditForm.tsx:100
msgid "Tagg bildet med stillinger"
msgstr ""

#: src/client/components/ImagesSection/ImagesEdit/ImagesEditForm.tsx:112
msgid "Taggede bilder brukes automatisk i kampanjer for denne stillingstypen."
msgstr ""

#: src/client/components/Onboarding/OnboardingEditorModal.tsx:33
msgid "Tagger du bildene med stillingsfunksjoner, brukes de automatisk i nettaviser og sosiale medier når du kjøper Pluss."
msgstr ""

#: src/client/components/AmbassadorsSection/AmbassadorForm.tsx:89
msgid "Tekst"
msgstr ""

#: src/client/components/ActiveAds/EmptyActiveAds.tsx:38
msgid "Til annonseoversikt"
msgstr ""

#: src/client/components/Onboarding/OnboardingEditModal.tsx:132
msgid "Tilbake"
msgstr ""

#: src/client/components/Hierarchy/ConfirmOrgConnectionModal.tsx:62
msgid "Tilknytning fjernet"
msgstr ""

#: src/client/components/Hierarchy/ConfirmOrgConnectionModal.tsx:54
msgid "Tilknytning opprettet"
msgstr ""

#: src/client/components/ProfileToolbar/Toolbar.tsx:21
#: src/islands/hierarchyPage/Hierarchy.tsx:28
msgid "Tilknytninger"
msgstr ""

#: src/client/components/Hierarchy/HierarchyFilter.tsx:57
#: src/client/components/Hierarchy/HierarchyRow.tsx:42
msgid "Tilknyttet"
msgstr ""

#: src/client/components/ImageEditor/ImageEditorModal.tsx:121
msgid "Tilpass og beskjær "
msgstr ""

#: src/client/components/AmbassadorsSection/AmbassadorForm.tsx:117
msgid "Tittel"
msgstr ""

#: src/client/components/ImageEditor/ImageEditorModal.tsx:62
msgid "toppbilde"
msgstr ""

#: src/islands/extendedProfilePage/ExtendedProfilePage.tsx:69
msgid "Tydelig profil"
msgstr ""

#: src/client/components/Hierarchy/ConfirmOrgConnectionModal.tsx:51
msgid "Tydelig Profil deles med hovedorganisasjonen (hvis aktivert)"
msgstr ""

#: src/client/components/EmptyMessage.tsx:35
msgid "Tydelig profil må settes opp av hovedkonto før dere kan bruke den. Når det"
msgstr ""

#: src/client/components/Hierarchy/HierarchyRow.tsx:67
msgid "underorganisasjoner"
msgstr ""

#: src/client/components/ExtendedProfileForm/LinkRow.tsx:61
msgid "URL"
msgstr ""

#: src/client/components/Hierarchy/ConfirmOrgConnectionModal.tsx:58
msgid "Ved å fjerne tilknytningen, vil {childName} slutte å bruke {motherName} sin bedriftsprofil."
msgstr ""

#: src/client/components/Hierarchy/ConfirmOrgConnectionModal.tsx:40
msgid "Ved tilknytning, vil {childName} sin nåværende bedriftsprofil bli deaktivert, og tilhørende profilinnhold vil ikke lenger benyttes."
msgstr ""

#: src/client/components/ExtendedProfileForm/ExtendedProfileForm.tsx:190
msgid "Velg én lenke å bruke som hovedknapp i kortet"
msgstr ""

#: src/client/components/ImagesSection/ImagesEdit/ImagesEditForm.tsx:110
msgid "Velg stilling"
msgstr ""

#: src/client/components/VideosSection/AddVideoField.tsx:30
msgid "Vennligst legg inn en gyldig YouTube- eller Vimeo-lenke"
msgstr ""

#: src/client/components/EmptyMessage.tsx:23
msgid "Vennligst prøv å søke på nytt."
msgstr ""

#: src/client/components/AmbassadorsSection/AmbassadorsSection.tsx:49
msgid "Vennligst rett opp feilene før du avslutter redigeringsmodus"
msgstr ""

#: src/client/components/EmptyMessage.tsx:34
msgid "Venter på oppsett fra hovedkonto"
msgstr ""

#: src/client/components/EmptyMessage.tsx:22
msgid "Vi finner ingen organisasjoner som matcher dine valgte kriterier."
msgstr ""

#: src/client/components/Onboarding/OnboardingEditModal.tsx:45
msgid "Vi har gjort det lettere for deg å organisere og redigere logo og innhold i bedriftsprofilen."
msgstr ""

#: src/client/api/api.ts:9
msgid "Vi har problemer med å laste denne siden. Prøv på nytt."
msgstr ""

#: src/client/components/AddSectionButton/AddSectionButton.tsx:44
msgid "Video"
msgstr ""

#: src/client/components/ExtendedProfileForm/ExtendedProfileModal.tsx:18
msgid "Vil du forlate uten å lagre endringene?"
msgstr ""

#: src/client/components/ProfileToolbar/EditModeToolbar.tsx:139
msgid "Vil du forlate uten å publisere?"
msgstr ""

#: src/client/components/Onboarding/OnboardingEditorTip.tsx:20
msgid "Vis frem bedriftskulturen med bilder, informasjon og sitat fra ansatte. En profesjonell profil tiltrekker flere kvalifiserte søkere."
msgstr ""

#: src/client/components/Onboarding/OnboardingEditorModal.tsx:32
msgid "Vis hvordan det er å jobbe hos dere med bilder og video."
msgstr ""

#: src/client/components/ActiveAds/ActiveAds.tsx:161
msgid "Vis mer"
msgstr ""

#: src/client/components/ExtendedProfileForm/ExtendedProfileForm.tsx:141
msgid "Vises øverst i profilkortet"
msgstr ""

#: src/client/components/ExtendedProfileForm/ExtendedProfileActivationSection.tsx:52
msgid "Vises på all nye annonser og du blir fakturert {extendedProfilePrice} kr ekstra per annonse."
msgstr ""
